export const COLUMN_ID = 'id';
export const COLUMN_NAME = 'name';
export const COLUMN_TYPE = 'type';
export const COLUMN_IS_MULTISELECT = 'isMultiselect';
export const COLUMN_BANNER = 'banner';
export const COLUMN_GIF = 'gif';
export const COLUMN_VIDEO = 'video';
export const COLUMN_CINEMAGRAPH = 'cinemagraph';
export const COLUMN_PLAYABLE = 'playable';
export const COLUMN_TAGS = 'tags';
